import type { ReactNode } from 'react'
import { usePermission } from '@/hooks/use-permission'
import type { PermissionMode, PermissionRequirement } from '@/lib/permissions'

/**
 * Permission-aware rendering, driven by `me.permissions`.
 *
 *   <Can permission="locations.manage"><Button>New location</Button></Can>
 *   <Can permission={['users.manage', 'roles.manage']} mode="all" fallback={<ReadOnly />}>…</Can>
 */
export function Can({
  permission,
  mode = 'any',
  fallback = null,
  children,
}: {
  permission: PermissionRequirement
  mode?: PermissionMode
  fallback?: ReactNode
  children: ReactNode | ((allowed: boolean) => ReactNode)
}) {
  const allowed = usePermission(permission, mode)
  if (typeof children === 'function') return <>{children(allowed)}</>
  return <>{allowed ? children : fallback}</>
}
